import styled from 'styled-components';
import { Heading } from '../../components/Pending/PendingHeader/Styles';

export const ClosingHeading = styled(Heading)`
  margin-bottom: 30px;
`;

export default ClosingHeading;
